
import { Component, Prop, Vue } from 'vue-property-decorator'
import { errorMessages } from '@/plugins/globalStaticDatas'

@Component
export default class STextField extends Vue {
  errorMessages: any = errorMessages
  @Prop({ default: '' }) id!: string
  @Prop({ default: '' }) name!: any
  @Prop({ default: false }) disabled!: boolean
  @Prop({ default: 'text' }) type!: string
  @Prop({ default: null }) label!: any
  @Prop({ default: null }) placeholder!: string
  @Prop({ default: null }) errors!: any
  @Prop({ default: null }) iconClass!: any
  @Prop() value!: string | number
  @Prop() min!: number
  @Prop() max!: number
  @Prop() maxlength!: number
  @Prop() required!: boolean
  @Prop() hasEmptyValue!: boolean

  get reactiveId() {
    return this.id || this.$id('snet-textfield')
  }

  hasError() {
    if (this.value === '') {
      return this.errors && this.errors.status === 422
    }
    return false
  }

  togglePasswordVisibility() {
    this.$emit('clickIcon')
  }
}
